import React from 'react';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const ScanDetails = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/ScanDetails')),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ScanDetailsView = (props: any) => {
  return <ScanDetails {...props.data} />;
};
